import React from "react";
import "../styles/About.css";
import stalingunaImage from "../imagesebf/stalin.jpg";
import {
  FaCalendarAlt,
  FaBookOpen,
  FaEye,
  FaMicrophoneAlt
} from "react-icons/fa";
import bookFestivalImage from "../imagesebf/mainlogo1.png";

const About = () => {
  const stats = [
    {
      icon: <FaCalendarAlt className="stat-icon" />,
      number: "20+",
      text: "வருடங்கள்" // Years
    },
    {
      icon: <FaBookOpen className="stat-icon" />,
      number: "10 லட்சங்கள் +",
      text: "புத்தகங்கள்" // Books
    },
    {
      icon: <FaEye className="stat-icon" />,
      number: "50 லட்சங்கள் +",
      text: "பார்வையாளர்கள்" // Viewers
    },
    {
      icon: <FaMicrophoneAlt className="stat-icon" />,
      number: "400 +",
      text: "சொற்பொழிவாளர்" // Speakers
    }
  ];

  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-titleprnt">
          <h1 className="about-hero-title">ஈரோடு புத்தகத் திருவிழா</h1>
          <p className="about-hero-subtitle">
            2005 முதல் அறிவு, பண்பாடு மற்றும் இலக்கியத்தை பரப்பும் ஒரு இயக்கம்
          </p>
          <a href="/posts" className="card-button pastpostbtn">
            2025 நிகழ்வுகள்
          </a>
        </div>
      </section>
      <div className="festival-container-abt">
        <h2 className="about-section-title">எங்கள் வரலாறு</h2>
        <div className="about-divider"></div>
        <div className="festival-layout-abt">
          <div className="image-container-abt">
            <img
              src={bookFestivalImage}
              alt="ஈரோடு புத்தக திருவிழா"
              className="festival-image-abt"
            />
          </div>

          <div className="content-container-abt">
            <div className="history-section-abt">
              <h2 className="section-title-abt">வரலாறு மற்றும் வளர்ச்சி</h2>
              <p className="section-content-abt">
                இந்த திருவிழா 2005 ஆம் ஆண்டில் தொடங்கப்பட்டது மற்றும்
                தமிழ்நாட்டில் சென்னைக்கு அடுத்தபடியாக இரண்டாவது பெரிய புத்தக
                திருவிழாவாக வளர்ந்துள்ளது...
              </p>
            </div>

            <div className="organizers-section-abt">
              <h2 className="section-title-abt">
                ஏற்பாடு செய்பவர்கள் மற்றும் இடம்
              </h2>
              <p className="section-content-abt">
                இது மக்கள் சிந்தனைப் பேரவை என்ற சமூக அமைப்பு மற்றும் மாவட்ட
                நிர்வாகத்தின் கூட்டு முயற்சியாகும்...
              </p>
              <p className="section-details-abt">
                <strong>இடம்:</strong> சிக்கய்ய அரசு கலை மற்றும் அறிவியல்
                கல்லூரி மைதானம், ஈரோடு
                <br />
                <strong>தேதி:</strong> ஆகஸ்ட் 1 முதல் 12 வரை
                <br />
                <strong>நேரம்:</strong> காலை 11 முதல் இரவு 9.30 வரை
                <br />
                தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு
              </p>
            </div>

            <div className="duration-section-abt">
              <h2 className="section-title-abt">கால அளவு மற்றும் நேரம்</h2>
              <p className="section-content-abt">
                இந்த திருவிழா பொதுவாக ஆகஸ்ட் 4 முதல் 15 வரை 12 நாட்கள்
                நடைபெறுகிறது...
              </p>
            </div>
          </div>
        </div>

        <div className="bottom-sections-abt">
          <div className="features-section-abt">
            <h2 className="section-title-abt">அளவு மற்றும் சிறப்பம்சங்கள்</h2>
            <p className="section-content-abt">
              ஈரோடு புத்தக திருவிழாவில் பல்வேறு வகைகள் மற்றும் பதிப்பகங்களின்
              தமிழ் மற்றும் ஆங்கிலத்தில் 230 கடைகள் உள்ளன...
            </p>
          </div>

          <div className="impact-section-abt">
            <h2 className="section-title-abt">
              தாக்கம் மற்றும் முக்கியத்துவம்
            </h2>
            <p className="section-content-abt">
              இந்த திருவிழா பொதுமக்கள் மற்றும் மாணவர்களிடையே புத்தக வாசிப்பு
              மற்றும் அறிவு வளர்ச்சியை ஊக்குவிப்பதை நோக்கமாகக் கொண்டுள்ளது...
            </p>
          </div>
        </div>
      </div>
      <section className="about-section fade-in">
        <h2 className="about-section-title">நிறுவனர்</h2>
        <div className="about-divider"></div>
        <div className="about-grid">
          <div className="about-grid-item">
            <div className="about-image-card hover-effect">
              <img
                src={stalingunaImage}
                alt="த. ஸ்டாலின் குணசேகரன்"
                className="about-image"
              />
            </div>
          </div>
          <div className="about-grid-item">
            <p className="about-text">
              த. ஸ்டாலின் குணசேகரன் (பிறப்பு: ஜூலை 15, 1954) ஒரு தமிழ்
              எழுத்தாளர், பத்திரிகையாளர் மற்றும் சமூக ஆர்வலர். இவர் ஈரோடு
              புத்தகத் திருவிழாவின் மூலமாக தமிழ் இலக்கியத்திற்கு பெரும்
              பங்களிப்பு செய்துள்ளார்.
            </p>
            <p className="about-text">
              "மக்கள் சிந்தனை" இதழின் ஆசிரியராக இருந்த இவர், பல சமூக
              இயக்கங்களில் ஈடுபட்டுள்ளார். இவரது எழுத்துக்கள் சமூக நீதி, மனித
              உரிமைகள் மற்றும் தமிழ் மொழி வளர்ச்சி பற்றியவை.
            </p>
          </div>
        </div>
      </section>
      <div className="about-container1">
        {/* Stats Section */}
        <section className="about-section about-stats-section fade-in">
          <h2 className="about-section-title">எங்கள் திருவிழா எண்களில்</h2>
          <div className="about-divider"></div>
          <div className="about-stats-container">
            {stats.map((stat, index) => (
              <div className="about-stat-item stat-hover-effect" key={index}>
                <div className="about-stat-icon">{stat.icon}</div>
                <h3 className="about-stat-number">{stat.number}</h3>
                <p className="about-stat-text">{stat.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Call to Action */}
        <section className="about-cta-section fade-in">
          <h2 className="about-cta-title">
            இந்த ஆண்டு புத்தகத் திருவிழாவில் பங்கேற்க விரும்புகிறீர்களா?
          </h2>
          <a className="card-button" href="/contact">
            எங்களை தொடர்பு கொள்ள
          </a>
        </section>
      </div>
    </div>
  );
};

export default About;
